import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetGuest } from "../../app/features/user/userSlice";
import { BeatLoader } from "react-spinners";
// import { setNochex } from "../../app/features/payment/paymentSlice";
import CountdownTimer from "./CountdownTimer";
import LogoMark from "../../gallery/default/logomark.png";

function EventGuestCheckoutForm({ createBooking }) {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.event.cart);
  const currentEvent = useSelector((state) => state.event.currentEvent);

  const isTimer = useSelector((state) => state.timer.isTimer);

  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    confirm_email: "",
    phone: "",
    address1: "",
    address2: "",
    location_id: "",
    postal_code: "",
    card_first_name: "",
    card_last_name: "",
    card_number: "",
    card_expiry: "",
    card_cvv: "",
    street_address: "",
  });

  const goToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const gotoLogin = () => dispatch(resetGuest());
  const handleChange = (event) => {
    setFormErrors({ ...formErrors, [event.target.name]: "" });
    if (event.target.name === "card_number") {
      let input = event.target.value;

      input = input.replace(/\D/g, "");

      input = input.replace(/(\d{4})(?=\d)/g, "$1 ");

      setFormData({ ...formData, [event.target.name]: input });
    } else if (event.target.name === "card_cvv") {
      let input = event.target.value;

      // Remove any non-digit characters
      input = input.replace(/\D/g, "");
      const isAmex = formData.card_number.startsWith("34") || formData.card_number.startsWith("37");
      if (isAmex) {
        input = input.slice(0, 4);
      } else {
        input = input.slice(0, 3);
      }
      setFormData({ ...formData, [event.target.name]: input });
    } else if (event.target.name === "card_expiry") {
      let input = event.target.value;

      // Remove any non-digit characters
      input = input.replace(/\D/g, "");

      // Format the input as MM/YY
      if (input.length > 2) {
        input = `${input.slice(0, 2)}/${input.slice(2, 4)}`;
      }
      setFormData({ ...formData, [event.target.name]: input });
    } else {
      setFormData({ ...formData, [event.target.name]: event.target.value });
    }
  };

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const validateForm = () => {
    let errors = {};

    // General Fields
    if (!formData.first_name) errors.first_name = "Enter first name";
    if (!formData.last_name) errors.last_name = "Enter last name";
    if (!formData.email || !isValidEmail(formData.email)) errors.email = "Enter a valid email";
    if (!formData.confirm_email || !isValidEmail(formData.confirm_email)) errors.confirm_email = "Enter a valid confirmation email";
    if (formData.email !== formData.confirm_email) errors.confirm_email = "Emails do not match";
    if (!formData.phone) errors.phone = "Enter your phone number";

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const registerUser = async (event) => {
    event.preventDefault();
    const loginButton = event.target;
    const loader = document.getElementById("checkoutloader");
    goToTop();
    if (validateForm()) {
      loginButton.classList.remove("btn-register");
      loginButton.classList.add("btn-disable-register");
      loader.style.display = "block";
      try {
        await createBooking(formData, true);
      } catch (error) {
        setFormErrors(error.response.data.message);
        setTimeout(() => {
          setFormErrors({});
        }, 5000);
        loginButton.classList.remove("btn-disable-register");
        loginButton.classList.add("btn-register");
        loader.style.display = "none";
        console.error(error);
      }
      loader.style.display = "none";
      loginButton.classList.remove("btn-disable-register");
      loginButton.classList.add("btn-register");
    }
  };

  return (
    <div className="login-container">
      <div className="row">
        <div className="col-12">
          <div className="col-12 d-flex justify-content-center mb-2">
            <img src={LogoMark} alt="Sahi Search" />
          </div>
          {isTimer && <CountdownTimer />}
          <p className="not-reserved">Tickets are not reserved until you have completed payment.</p>
          <h3 className="login-event-title">{currentEvent.name}</h3>
          <p className="ticket-waiting">
            {cart.productsCount}&nbsp;
            {cart.productsCount === 1 ? "ticket waiting" : "tickets waiting"}
          </p>
          <p className="inclusive-fee">All ticket prices are inclusive of booking fees</p>
          <h3 className="grand-total">
            {cart.discount > 0 && <span className="discount-applied-success">£{cart.subTotal.toFixed(2)}</span>}
            &nbsp; £{cart.grandTotal.toFixed(2)}
          </h3>
          <form className=" g-3 mt-2" autoComplete="off">
            <div className="row">
              <p className="required">
                <span className="field-required">*</span>Required
              </p>
              <div className="col-md-6 col-12 mb-3">
                <label htmlFor="first_name" className="form-label input-label">
                  First name<span className="field-required">*</span>
                </label>
                <input type="text" className={`form-control input-text-size ${formErrors.first_name ? "error-input" : ""}`} name="first_name" placeholder="First name" onChange={handleChange} value={formData.first_name} required={"required"} />
                {formErrors.first_name && <span className="error-text">{formErrors.first_name}</span>}
              </div>
              <div className="col-md-6 col-12 mb-3">
                <label htmlFor="last_name" className="form-label input-label">
                  Last name<span className="field-required">*</span>
                </label>
                <input type="text" className={`form-control input-text-size ${formErrors.last_name ? "error-input" : ""}`} name="last_name" placeholder="Last name" onChange={handleChange} value={formData.last_name} required={"required"} />
                {formErrors.last_name && <span className="error-text">{formErrors.last_name}</span>}
              </div>
              <div className="col-12 mb-3">
                <label htmlFor="email" className="form-label input-label">
                  Email<span className="field-required">*</span>
                </label>
                <input type="email" className={`form-control input-text-size ${formErrors.email ? "error-input" : ""}`} name="email" placeholder="Your email" onChange={handleChange} value={formData.email} required={"required"} />
                {formErrors.email && <span className="error-text">{formErrors.email}</span>}
              </div>
              <div className="col-12 mb-3">
                <label htmlFor="confirm_email" className="form-label input-label">
                  Confirm Email<span className="field-required">*</span>
                </label>
                <input type="email" className={`form-control input-text-size ${formErrors.confirm_email ? "error-input" : ""}`} name="confirm_email" placeholder="Your email address again" onChange={handleChange} value={formData.confirm_email} required={"required"} />
                {formErrors.confirm_email && <span className="error-text">{formErrors.confirm_email}</span>}
              </div>
              <div className="col-12 mb-3">
                <label htmlFor="phone" className="form-label input-label">
                  Phone number<span className="field-required">*</span>
                </label>
                <input type="text" className={`form-control input-text-size ${formErrors.phone ? "error-input" : ""}`} name="phone" placeholder="Your phone number" onChange={handleChange} value={formData.phone} required={"required"} />
                {formErrors.phone && <span className="error-text">{formErrors.phone}</span>}
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-12 text-center">
                <button type="button" className="btn btn-register mb-3" onClick={registerUser}>
                  Pay now
                </button>
                <div className="mt-3" id="checkoutloader" style={{ display: "none" }}>
                  <BeatLoader color="#C6153B" />
                  <h4 className="mt-3" style={{ color: "#C6153B" }}>
                    Loading Payment Gateway...
                  </h4>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="col-12 mt-3">
          <div className="event-align-middle">
            <button className="btn btn-back mb-2" onClick={gotoLogin}>
              Go back to login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventGuestCheckoutForm;
